import { HttpHeaders } from '@angular/common/http';

export function getSkipperErrorHeader(avoid: boolean): HttpHeaders {
  return avoid ? new HttpHeaders().set('Skip-Error-Display', 'true') : new HttpHeaders();
}
